import Input from '@amzn/meridian/input';
import { localizeWithRef } from './localize';

export default localizeWithRef(Input, ['label', 'placeholder', 'prefix', 'suffix']);
